import styles from '../PlanCard.module.scss';

interface AlexRecommendedBadgeProps {
  className?: string;
  starSize?: 'small' | 'large';
}

export default function AlexRecommendedBadge({
  className,
  starSize = 'large',
}: AlexRecommendedBadgeProps) {
  return (
    <div
      className={`${styles.planRecommendedBadge}${
        className ? ` ${className}` : ''
      }`}
    >
      {starSize === 'large' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          aria-hidden="true"
        >
          <rect width="20" height="20" rx="10" fill="white" />
          <path
            d="M18.3039 8.97265L14.7882 12.0062L15.8593 16.543C15.9184 16.7892 15.9032 17.0475 15.8156 17.2851C15.728 17.5228 15.5719 17.7291 15.3671 17.8781C15.1623 18.0271 14.9179 18.112 14.6648 18.1221C14.4118 18.1323 14.1614 18.0672 13.9453 17.9352L9.99995 15.507L6.0523 17.9352C5.83622 18.0665 5.58613 18.1309 5.3335 18.1204C5.08087 18.1099 4.837 18.0248 4.63261 17.876C4.42822 17.7271 4.27243 17.5211 4.18488 17.2839C4.09732 17.0467 4.08191 16.7889 4.14058 16.543L5.21558 12.0062L1.69995 8.97265C1.50878 8.80742 1.37052 8.58954 1.30244 8.3462C1.23436 8.10287 1.23947 7.84487 1.31715 7.60442C1.39483 7.36398 1.54162 7.15175 1.73919 6.99423C1.93677 6.83672 2.17637 6.7409 2.42808 6.71874L7.03745 6.34687L8.81558 2.04375C8.91182 1.80923 9.07563 1.60863 9.28618 1.46745C9.49673 1.32627 9.7445 1.25089 9.998 1.25089C10.2515 1.25089 10.4993 1.32627 10.7098 1.46745C10.9204 1.60863 11.0842 1.80923 11.1804 2.04375L12.9578 6.34687L17.5671 6.71874C17.8193 6.74007 18.0596 6.83536 18.2579 6.99266C18.4562 7.14995 18.6037 7.36227 18.6819 7.60301C18.76 7.84374 18.7654 8.10219 18.6973 8.34597C18.6292 8.58975 18.4907 8.80802 18.2992 8.97343L18.3039 8.97265Z"
            fill="#2DA7C6"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          aria-hidden="true"
        >
          <rect width="14" height="14" rx="7" fill="white" />
          <path
            d="M12.8127 6.28097L10.3518 8.40448L11.1015 11.5802C11.1429 11.7526 11.1322 11.9334 11.0709 12.0997C11.0096 12.2661 10.9003 12.4105 10.757 12.5148C10.6136 12.6191 10.4425 12.6785 10.2654 12.6856C10.0882 12.6927 9.91296 12.6472 9.76168 12.5547L6.99997 10.855L4.23661 12.5547C4.08536 12.6466 3.91029 12.6918 3.73345 12.6844C3.55661 12.677 3.3859 12.6175 3.24283 12.5133C3.09975 12.4091 2.9907 12.2649 2.92941 12.0989C2.86812 11.9328 2.85734 11.7524 2.8984 11.5802L3.6509 8.40448L1.18997 6.28097C1.05614 6.16531 0.959362 6.01279 0.911706 5.84246C0.86405 5.67212 0.867632 5.49152 0.922005 5.32321C0.976378 5.1549 1.07913 5.00634 1.21743 4.89608C1.35574 4.78581 1.52346 4.71874 1.69965 4.70323L4.92622 4.44292L6.1709 1.43073C6.23828 1.26657 6.35294 1.12615 6.50032 1.02733C6.64771 0.9285 6.82115 0.875732 6.9986 0.875732C7.17605 0.875732 7.34949 0.9285 7.49687 1.02733C7.64426 1.12615 7.75892 1.26657 7.82629 1.43073L9.07043 4.44292L12.297 4.70323C12.4735 4.71817 12.6418 4.78486 12.7806 4.89497C12.9194 5.00508 13.0226 5.1537 13.0773 5.32222C13.132 5.49073 13.1358 5.67165 13.0881 5.84229C13.0405 6.01294 12.9435 6.16573 12.8094 6.28152L12.8127 6.28097Z"
            fill="#2DA7C6"
          />
        </svg>
      )}
      <span>ALEX Recommended</span>
    </div>
  );
}
